const baseURL = 'https://lwstkhyl.me';
const timeout = 10000;
module.exports = {
    userName: 'lwstkhyl',
    baseURL,
    timeout,
}
